import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { CustomIcon } from "..";
import "./index.scss";
import Cookies from "js-cookie";

const LanguageSwitcher: React.FC = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { i18n } = useTranslation();

  const changeLanguage = (lng: "en" | "fa" | "tr") => {
    i18n.changeLanguage(lng);
    Cookies.set("lng", lng);
  };

  const dropDownToggleHandler = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <div id="custom-dropdown-icon">
      <section
        id="custom-dropdown-icon-container"
        // className={type ? `custom-icon-${type}` : ""}
        // onClick={onClick}
      >
        <div className="tooltip-hover">
          <span>{"تغییر زبان"}</span>
          <div className="after-arrow"></div>
        </div>
        <div className="icon" onClick={dropDownToggleHandler}>
          <i className={"fa-regular fa-globe"}></i>
          <i className="fa-regular fa-caret-down"></i>
        </div>
      </section>
      <ul className={`dropdown ${isOpen ? "open" : "close"}`}>
        <li
          onClick={() => {
            dropDownToggleHandler();
            changeLanguage("fa");
          }}
        >
          فارسی
        </li>
        <li
          onClick={() => {
            dropDownToggleHandler();
            changeLanguage("en");
          }}
        >
          English
        </li>
        <li
          onClick={() => {
            dropDownToggleHandler();
            changeLanguage("tr");
          }}
        >
          turkey
        </li>
      </ul>
    </div>
    // <div>
    //   <label>Select Language:</label>
    //   <select onChange={(e) => changeLanguage(e.target.value)}>
    //     <option value="fa">فارسی</option>
    //     <option value="en">English</option>
    //     <option value="tr">turkey</option>
    //     {/* Add more languages as needed */}
    //   </select>
    // </div>
  );
};

export default LanguageSwitcher;
